import React, { Component } from 'react';

class NavMobile extends Component {

  constructor( props ) {
    super(props);
  }

  getNavBarBodyHTML() {

    let html = this.props.topNavPages.map( (item, index) =>
     <div key={index} className="nav-list-body">
       <h2>{item[0].title}</h2>
       <ul className="nav-category-list nav-list">
        {this.getNavBarBodyInnerHTML(item[0].property)}
       </ul>
     </div>
    );

    return html;

  }

  getThreeSupreme(){
    /*
    let html = this.props.threeSupreme.map( ( item, index ) =>
      <div key={index} className="nav-list-body">
        <h2><a href={item[0].link} style={{color:'inherit'}}>{item[0].title}</a></h2>
      </div>
    );
    return html;
    */
  }

  getNavBarBodyInnerHTML(item) {
    let html = this.props.topNavBody[item].left.map( ( item, index ) =>
      <li key={index}><a href={item.link}>{item.title}</a></li>
    );
    return html;
  }

  getNavBarPromoHTML() {
    let data = this.props.topNavBody.buy.right[0][0];

    return (
      <div className="nav-list-body nav-onsell-block">
        <h3>{data.title}</h3>
        <ul className="nav-onsell-list nav-list">
          {this.getNavBarPromoListHTML(data.items)}
        </ul>
      </div>
    );
  }

  getNavBarPromoListHTML(items) {
    let html = items.map( (item, index ) =>
      <li key={index}><a href={item.href}>{item.label}</a></li>
    );
    return html;
  }

  getLoginHTML() {
    var logoutURL = this.props.login.logoutHref + window.current_url;

    if(this.props.isLogin) {
      return(
        <a href={logoutURL}>
          <span className="v-align-middle"></span>
          <img src={this.props.login.loggedInSrc} className="navbar-icon" alt="" />
          <span className="navbar-label">{this.props.userName}</span>
          {/* <span className="navbar-label">{this.props.login.logoutLabel}</span> */}

        </a>
      );
    }
    else {
      return(
        <a href={this.props.login.href}>
          <span className="v-align-middle"></span>
          <img src={this.props.login.src} className="navbar-icon" alt="" />
          <span className="navbar-label">{this.props.login.label}</span>
        </a>
      );
    }
  }



  render() {
    return (

    <div id="navbar-xs">
      <div className="navbar-top-border"></div>
      <nav className="navbar-top">
        <div className="navbar-top-left">
          {this.getLoginHTML()}
        </div>
        <div className="navbar-top-right">
          <span className="v-align-middle"></span>
          <button type="button" className="btn-image navbar-menu navbar-close">
            <img src="/assets/images/nav/close.png" className="navbar-icon" alt="Close" />
          </button>
        </div>
      </nav>{/*<!-- navbar top END -->*/}
      <div className="navbar-body">

          {this.getNavBarBodyHTML()}
          {this.getThreeSupreme()}
          {this.getNavBarPromoHTML()}

      </div>{/*<!-- navbar body END -->*/}
      <div className="navbar-3business">
        {
          this.props.mobileNav.footer && 
            <a href={this.props.mobileNav.footer.business.url}><img src={this.props.mobileNav.footer.business.image} alt={this.props.mobileNav.footer.business.alt} /></a>          
        }
      </div>
      <div className="navbar-footer">
        <div className="navbar-footer-block">
          {this.props.mobileNav.src && <img src={this.props.mobileNav.src} className="navbar-footer-icon" alt={this.props.mobileNav.alt} />}
          <div className="navbar-footer-right-block">
            <h3>{this.props.mobileNav.title}</h3>
            <p>
              {this.props.mobileNav.copyright1}
            </p>
            <p>
              {this.props.mobileNav.copyright2}
            </p>
          </div>
        </div>
      </div>
    {/*<!-- navbar mobile END -->*/}
    </div>

    );
  }
}

export default NavMobile;
